import React from "react";
import defaultMenuItems from "../../../../../menu-items";
import NavGroup from "./NavGroup";

function Navigation({ items }) {
  const menuItems = items || defaultMenuItems;
  const navGroups = menuItems.items.map((item) => {
    if (item.type === "group") {
      return <NavGroup key={item.id} item={item} />;
    }
    return null;
  });

  return <div style={styles.nav}>{navGroups}</div>;
}

const styles = {
  nav: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
};

export default Navigation;
